(() => {
  const initializeBundleBuilder = (root) => {
  if (!root || root.dataset.dtPdpBundleReady === 'true') return;
  root.dataset.dtPdpBundleReady = 'true';

    const sheet = root.querySelector('[data-dt-pdp-bundle-sheet]');
    const frameWrap = root.querySelector('[data-dt-pdp-bundle-frame-wrap]');
    const loading = root.querySelector('[data-dt-pdp-bundle-loading]');
    const builder = root.querySelector('[data-dt-pdp-bundle-builder]');
    const productData = root.querySelector('[data-dt-pdp-bundle-product]');
    const savingCopy = root.querySelector('[data-dt-pdp-bundle-saving-copy]');
    const openButtons = root.querySelectorAll('[data-dt-pdp-bundle-open]');
    const mode = root.dataset.bundleMode || 'pdp';
    const isFreebies = root.dataset.freebies === 'true';
    const freebiesCheckoutEnabled = root.dataset.giftsReady === 'true';
    const offerUrl = root.dataset.offerUrl || '/apps/gbb/easybundle/buy-3-at-2499';
    const offerId = root.dataset.offerId || 'SDK-032354';
    const bundleOfferName = root.dataset.bundleOfferName || 'Buy 3 at ₹2499';
    const offerImage = root.dataset.offerImage || '';
    const originHandle = root.dataset.originHandle || '';
    const bundlePrice = Number(root.dataset.bundlePrice || 249900);
const shopDomain = root.dataset.shopDomain || '';
const sectionId = String(root.dataset.sectionId || 'bundle');
const assetUrls = {
  delete: root.dataset.assetDelete || '',
  emptySlot: root.dataset.assetEmptySlot || '',
  gift: root.dataset.assetGift || '',
  giftWhite: root.dataset.assetGiftWhite || '',
  giftBeige: root.dataset.assetGiftBeige || '',
  giftSage: root.dataset.assetGiftSage || '',
  progress: root.dataset.assetProgress || '',
  chevron: root.dataset.assetChevron || '',
  productClose: root.dataset.assetProductClose || '',
  starFilled: root.dataset.assetStarFilled || '',
  starEmpty: root.dataset.assetStarEmpty || '',
  specifications: root.dataset.assetSpecifications || '',
  productDetails: root.dataset.assetProductDetails || '',
  usageCare: root.dataset.assetUsageCare || '',
  disclaimer: root.dataset.assetDisclaimer || '',
  detailChevron: root.dataset.assetDetailChevron || ''
};
    const freeGiftProducts = [
      { color: 'Simply White', image: assetUrls.giftWhite },
      { color: 'Biscotti Beige', image: assetUrls.giftBeige },
      { color: 'Sage Green', image: assetUrls.giftSage }
    ];
    const getFreeGiftCount = (variantId) => ({
      '54874685571285': 1,
      '54874703790293': 2,
      '54874707165397': 3
    })[String(variantId)] || 0;
    const getFreeGiftItems = (count) => freeGiftProducts.slice(0, count).map((gift) => ({
      imageUrl: gift.image || assetUrls.gift,
      price: 0,
      isGift: true,
      title: 'Banana Super Light Weight Terry Towel',
      color: gift.color,
      uniqueKey: ''
    }));
    const loadBudgetMs = 1200;
    let previousFocus = null;
    let syncedVariantId = '';
    let cartDrawerPending = false;
    let cartRuntimePromise = null;
    let pendingDrawerTimer = null;
    let pendingDrawerOpened = false;
    let closeTimer = null;
    let bundleInstance = null;
    let instancePromise = null;
    let renderFrame = 0;
    let renderedCatalogKey = '';
    let visibleCategoryCount = mode === 'page' ? 1 : Number.POSITIVE_INFINITY;
    let categoryRevealObserver = null;
    let isFooterExpanded = false;
    let hasPrefilledCurrentProduct = false;
    let productDetailsSheet = null;
    let productDetailsCard = null;
    let productDetailsProduct = null;
    let productDetailsVariantId = '';
    let productDetailsPreviousFocus = null;
    let productDetailsCloseTimer = null;
    const sharedRuntime = window.dtBundleBuilderRuntime || (window.dtBundleBuilderRuntime = {});
    const productDetailsCache = sharedRuntime.productDetailsCache || (sharedRuntime.productDetailsCache = new Map());
    const bundleDataCache = sharedRuntime.bundleDataCache || (sharedRuntime.bundleDataCache = new Map());

    const waitForEasyBundleSdk = () => {
      if (!sharedRuntime.sdkReady) {
        sharedRuntime.sdkReady = new Promise((resolve, reject) => {
          const startedAt = performance.now();
          const check = () => {
            if (window.gbbSdk && typeof window.gbbSdk.init === 'function') {
              resolve(window.gbbSdk);
              return;
            }
            if (performance.now() - startedAt >= 6000) {
              reject(new Error('EasyBundle is unavailable'));
              return;
            }
            window.setTimeout(check, 50);
          };
          check();
        });
      }
      return sharedRuntime.sdkReady;
    };

    const fetchBundleData = () => {
      if (bundleDataCache.has(offerId)) return bundleDataCache.get(offerId);
      const loadBundleData = () => window.fetch('https://gift-box-builder-app4.s3.us-east-2.amazonaws.com/public/backup-config/' + encodeURIComponent(shopDomain) + '/' + encodeURIComponent(offerId) + '.json')
        .then((response) => {
          if (!response.ok) throw new Error('Bundle configuration is unavailable');
          return response.json();
        });
      const earlyRequest = window.__dtBundleDataPromises?.[offerId];
      const request = (earlyRequest || loadBundleData())
        .then((data) => data || loadBundleData())
        .then((data) => data?.bundleData || data?._bundleData || data?.stepsConfigurationData || data)
        .catch((error) => {
          bundleDataCache.delete(offerId);
          throw error;
        });
      bundleDataCache.set(offerId, request);
      return request;
    };

    const createBundleInstance = async (sdk) => {
      const useFreebiesOffer = mode === 'page' && isFreebies && originHandle === 'freebies' && offerId === 'SDK-548269';
      if (useFreebiesOffer) {
        const bundleData = await fetchBundleData();
        if (bundleData?.offerId !== offerId) throw new Error('Freebies bundle configuration does not match');
        const settings = window.easybundles_preResolvedSettings || window.easybundles_ext_data || window.easybundle_active_bundle_data;
        if (!settings?.userData) throw new Error('Freebies bundle settings are unavailable');
        // The product still carries the older offer in Shopify. Resolve the complete intended offer before SDK initialization.
        const resolvedSettings = { ...settings, _preResolvedBundle: true, _bundleData: bundleData };
        window.easybundles_preResolvedSettings = resolvedSettings;
        window.easybundle_active_bundle_data = resolvedSettings;
        window.easybundle_full_page_ext_data = resolvedSettings;
      }
      try {
        const instance = await sdk.init({ offerId });
        if (useFreebiesOffer && instance?.bundleData?.offerId !== offerId) {
          throw new Error('Freebies builder loaded a different offer');
        }
        return instance;
      } catch (error) {
        if (mode !== 'page' || !/bundleData is required/i.test(String(error?.message || error))) throw error;
        const bundleData = await fetchBundleData();
        if (typeof sdk.initialize !== 'function') throw error;
        return sdk.initialize(bundleData);
      }
    };

    const warmBundleBuilder = () => {
      if (navigator.connection && navigator.connection.saveData) return;
      ensureBundleInstance().catch(() => {});
    };

    const trackBundle = (eventName) => {
      const payload = {
        bundle_offer: bundleOfferName,
        bundle_price: bundlePrice / 100,
        source_pdp: originHandle
      };
      window.DTJourney?.track?.('dt_bundle_' + eventName, {
        ...payload,
        source: originHandle ? 'product:' + originHandle : 'bundle',
        placement: 'bundle-builder'
      });
      if (typeof window.gtag !== 'function') return;
      window.gtag('event', 'dt_upsell_bundle_' + eventName, payload);
    };

    if (mode === 'pdp' && sheet && sheet.parentElement !== document.body) {
      document.body.appendChild(sheet);
    }

    const getProductPayload = () => {
      if (mode !== 'pdp' || !productData) return null;
      try {
        const payload = JSON.parse(productData.textContent || '{}');
        const variantInput = root.closest('.shopify-section')?.querySelector('.product-variant-id') || document.querySelector('.product-variant-id');
        const urlVariantId = new URLSearchParams(window.location.search).get('variant');
        const variantId = variantInput && variantInput.value ? variantInput.value : (urlVariantId || payload.variantId);
        const variants = Array.isArray(payload.variants) ? payload.variants : [];
        const selectedVariant = variants.find((variant) => String(variant.variantId || variant.id) === String(variantId)) || null;
        payload.variantId = String(variantId);
        payload.selectedVariant = selectedVariant || {
          variantId: String(variantId),
          id: 'gid://shopify/ProductVariant/' + String(variantId),
          variantGraphqlId: 'gid://shopify/ProductVariant/' + String(variantId),
          price: 0,
          compareAtPrice: 0
        };
        payload.variantGid = payload.selectedVariant.variantGraphqlId || payload.selectedVariant.admin_graphql_api_id || payload.selectedVariant.id || ('gid://shopify/ProductVariant/' + String(variantId));
        payload.variants = variants.length ? variants : [payload.selectedVariant];
        return payload;
      } catch (error) {
        return null;
      }
    };

    const getCurrentVariantId = () => {
      const payload = getProductPayload();
      return payload && payload.variantId ? String(payload.variantId) : '';
    };

    const formatRupees = (value) => {
      const amount = Math.max(0, Math.round(Number(value || 0) / 100));
      return '₹' + amount.toLocaleString('en-IN');
    };

    const updateSavingCopy = () => {
      if (mode !== 'pdp' || !savingCopy) return;
      const payload = getProductPayload();
      const selectedVariant = payload && payload.selectedVariant ? payload.selectedVariant : null;
      const mrp = Number(selectedVariant && (selectedVariant.compareAtPrice || selectedVariant.compare_at_price || selectedVariant.price) ? (selectedVariant.compareAtPrice || selectedVariant.compare_at_price || selectedVariant.price) : 0);
      const saving = Math.max(0, (mrp * 3) - bundlePrice);
      savingCopy.innerHTML = 'Save upto <span class="dt-pdp-bundle__saving">' + formatRupees(saving) + '</span> on this bundle';
    };

    const getBundleCategories = () => {
      if (!bundleInstance) return [];
      return bundleInstance.f.getAllStepsData().flatMap((step) => Object.values(step.categories || {}))
        .filter((category) => !isFreebies || category.categoryId !== 'addonProduct');
    };

    const hasRenderableProducts = () => getBundleCategories().some((category) => {
      return (category.products || []).some((product) => Boolean(getProductVariant(product, '')));
    });

    const getCategoryLimit = (category) => {
      const rules = category?.conditions?.rules || [];
      return rules.reduce((limit, rule) => {
        if (rule.type !== 'quantity') return limit;
        const value = Number(rule.value || 0);
        return value > limit ? value : limit;
      }, 0);
    };

    const getCategoryItems = (categoryId) => bundleInstance
      ? bundleInstance.f.getCategoryCartItems(categoryId, { mergeBogo: true })
      : [];

    const getItemVariantId = (item) => String(item?.variantId || item?.variant_id || item?.id || '');

    const getProductVariant = (product, variantId) => {
      const variants = (product?.variants || []).filter((variant) => variant.available !== false && variant.availableForSale !== false);
      return variants.find((variant) => String(variant.id || variant.variantId) === String(variantId)) || variants[0] || null;
    };

    const getProductImage = (product, variant) => {
      const image = variant?.image || variant?.featured_image?.src || variant?.featured_media?.src
        || product?.featuredImage?.transformedSrc || product?.featuredImage?.originalSrc || product?.featured_image;
      return typeof image === 'string' ? image : image?.src || '';
    };

    const getCardTitle = (product) => String(product?.title || '').split('|')[0].trim();

    const formatCardPrice = (value) => 'Rs. ' + Math.max(0, Math.round(Number(value || 0) / 100)).toLocaleString('en-IN');

    const getFreebiesProductRank = (product) => {
      const title = getCardTitle(product).toLowerCase();
      if (title.includes('thirsty')) return 3;
      if (title.includes('banana double cloth') || title.includes('aluvera') || title.includes('aloe vera') || title.includes('banana jacquard') || title.includes('banana super light')) return 0;
      const price = Math.max(...(product?.variants || []).map((variant) => Number(variant.price || 0)), Number(product?.price || 0));
      return price >= 249900 ? 1 : 2;
    };

    const sortFreebiesProducts = (products) => {
      if (!isFreebies) return products;
      return [...products].sort((first, second) => getFreebiesProductRank(first) - getFreebiesProductRank(second));
    };

    const getCategoryHeading = (category) => {
      if (isFreebies) return 'Choose your towels';
      const limit = getCategoryLimit(category);
      const rawHeading = String(category?.name || category?.title || '').trim();
      const heading = !rawHeading || /^Category\s+\d+$/i.test(rawHeading)
        ? 'Choose any ' + (limit || 3)
        : rawHeading;
      if (/towel/i.test(heading)) return heading;
      const productTitles = (category?.products || []).map(getCardTitle).filter(Boolean);
      const mostly = (pattern) => productTitles.filter((title) => pattern.test(title)).length >= Math.ceil(productTitles.length * .7);
      if (productTitles.length && mostly(/bath towels?/i)) return heading + ' Bath Towel';
      if (productTitles.length && mostly(/hair towels?/i)) return heading + ' Hair Towel';
      if (productTitles.length && mostly(/hand towels?/i)) return heading + ' Hand Towel';
      if (productTitles.length && mostly(/face towels?/i)) return heading + ' Face Towel';
      return heading;
    };

    const syncCurrentProductVariant = () => {
      if (!bundleInstance) return;
      const payload = getProductPayload();
      if (!payload?.variantId) return;
      const productId = String(payload.productId || payload.id || '');
      const category = getBundleCategories().find((entry) => (entry.products || []).some((product) => {
        if (String(product.id || product.productId) === productId) return true;
        return (product.variants || []).some((variant) => String(variant.id || variant.variantId) === String(payload.variantId));
      }));
      if (!category) return;

      const currentItems = getCategoryItems(category.categoryId);
      if (currentItems.length === 1 && getItemVariantId(currentItems[0]) === String(payload.variantId)) {
        hasPrefilledCurrentProduct = true;
        return;
      }

      currentItems.forEach((item) => {
        const uniqueId = item?.properties?._uniqueGbbSdkItemKey;
        if (uniqueId) bundleInstance.f.updateCartItem(uniqueId, { quantity: 0, showToast: false });
      });

      const result = bundleInstance.f.addProductToBundle({
        categoryId: category.categoryId,
        stepId: category.stepId,
        variantId: Number(payload.variantId),
        quantity: 1,
        showToast: false
      });
      hasPrefilledCurrentProduct = Boolean(result?.ok);
    };

    const clearPageSelection = () => {
      if (mode !== 'page' || !bundleInstance) return;
      getBundleCategories().forEach((category) => {
        getCategoryItems(category.categoryId).forEach((item) => {
          const uniqueId = item?.properties?._uniqueGbbSdkItemKey;
          if (uniqueId) bundleInstance.f.updateCartItem(uniqueId, { quantity: 0, showToast: false });
        });
      });
    };

    const scheduleBundleRender = () => {
      if (renderFrame) return;
      renderFrame = requestAnimationFrame(() => {
        renderFrame = 0;
        renderBundleBuilder();
      });
    };

    const updateProductCards = (categories) => {
      builder.querySelectorAll('.dt-pdp-bundle-builder__product').forEach((card) => {
        const category = categories.find((entry) => String(entry.categoryId) === String(card.dataset.categoryId));
        const product = category?.products?.find((entry) => String(entry.id || entry.productId) === String(card.dataset.productId));
        if (!category || !product) return;
        const selectedItems = getCategoryItems(category.categoryId);
        const selectedItem = selectedItems.find((item) => String(item.product_id || item.productId) === String(card.dataset.productId));
        const variant = getProductVariant(product, selectedItem ? getItemVariantId(selectedItem) : card.dataset.variantId);
        if (!variant) return;
        const variantId = String(variant.id || variant.variantId);
        const isSelected = selectedItems.some((item) => getItemVariantId(item) === variantId);
        const selectedQuantity = selectedItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
        const isFull = getCategoryLimit(category) > 0 && selectedQuantity >= getCategoryLimit(category);
        const isUnavailable = !isSelected && isFull;
        card.dataset.variantId = variantId;
        card.classList.toggle('is-selected', isSelected);
        card.classList.toggle('is-unavailable', isUnavailable);
        if (isUnavailable) card.setAttribute('aria-disabled', 'true');
        else card.removeAttribute('aria-disabled');
        card.querySelectorAll('.dt-pdp-bundle-builder__swatch').forEach((swatch) => {
          swatch.setAttribute('aria-pressed', String(swatch.dataset.variantId === variantId));
        });
        const image = card.querySelector('.dt-pdp-bundle-builder__image');
        const price = card.querySelector('.dt-pdp-bundle-builder__price');
        const toggle = card.querySelector('.dt-pdp-bundle-builder__toggle');
        if (image) image.src = getProductImage(product, variant);
        if (price) price.textContent = formatCardPrice(variant.price || product.price || 0);
        if (toggle) {
          toggle.classList.toggle('is-selected', isSelected);
          toggle.disabled = isUnavailable;
          toggle.innerHTML = '<span class="dt-pdp-bundle-builder__toggle-icon" aria-hidden="true">' + (isSelected ? '−' : '+') + '</span><span>' + (isSelected ? 'Remove' : 'Add') + '</span>';
        }
      });
    };

    const syncFreebie = () => {
      if (!isFreebies) return true;
      const addons = bundleInstance.addons?.f;
      if (!addons || !addons.isEnabled()) return false;
      const eligible = addons.calculateEligibleTier();
      if (!eligible) return true;
      const products = addons.getAddonProductsByTierId(eligible.tierId);
      const variant = products?.[0]?.variants?.[0];
      const variantId = variant?.variantId || variant?.id;
      if (!variantId) return false;
      const gifts = addons.getAddonsFromCart();
      if (gifts.length === 1 && String(getItemVariantId(gifts[0])) === String(variantId) && gifts[0].quantity === 1) return true;
      gifts.forEach((gift) => bundleInstance.f.updateCartItem(gift.properties._uniqueGbbSdkItemKey, { quantity: 0, showToast: false }));
      return Boolean(bundleInstance.f.addProductToBundle({ categoryId: 'addonProduct', variantId, quantity: 1, showToast: false })?.ok);
    };

    const renderBundleBuilder = () => {
      if (!builder || !bundleInstance) return;
      if (isFreebies) root.dataset.giftsReady = String(syncFreebie());
      const allCategories = getBundleCategories();
      const categories = allCategories.slice(0, visibleCategoryCount);
      const cartItems = bundleInstance.f.getCartItems({ mergeBogo: true });
      const selectedCount = cartItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const purchaseTotal = cartItems.filter((item) => !item.properties?._addon_product)
        .reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0), 0);
      const payableTotal = isFreebies ? purchaseTotal : bundlePrice;
      let rewardMessage = '';
      let nextRewardMessage = '';
      let rewardProgress = 0;
      let unlockedTier = 0;
      if (isFreebies) {
        const addonTiers = bundleInstance.f.getBundleConfig()?.personalizationData?.addonProducts?.tiers || [];
        const tiers = addonTiers.map((tier) => Math.round(Number(tier.eligibilityCondition?.value || 0) * 100));
        if (tiers.length !== 3 || tiers.some((amount) => !Number.isFinite(amount) || amount <= 0)) return;
        unlockedTier = tiers.filter((amount) => purchaseTotal >= amount).length;
        const next = tiers[unlockedTier];
        const previous = tiers[unlockedTier - 1] || 0;
        rewardProgress = next ? Math.max(0, Math.min(100, (purchaseTotal - previous) / (next - previous) * 100)) : 100;
        const giftValue = Math.round(Number(addonTiers[unlockedTier - 1]?.selectedAddonProducts?.[0]?.variants?.[0]?.price || 0) * 100);
        const amountMarkup = (amount) => '<strong>' + escapeHtml(formatRupees(amount)) + '</strong>';
        rewardMessage = unlockedTier
          ? 'Congrats! You’ve unlocked gifts worth ' + amountMarkup(giftValue) + '.'
          : 'Add ' + amountMarkup(next - purchaseTotal) + ' more to unlock your first gift.';
        if (unlockedTier && next) nextRewardMessage = 'Add ' + amountMarkup(next - purchaseTotal) + ' more to unlock next gift.';
        if (unlockedTier && !next) nextRewardMessage = 'All gifts unlocked · 3 free bath towels included.';
        if (unlockedTier && root.dataset.giftsReady !== 'true') {
          rewardMessage = 'Your free gift is unavailable. Please try again.';
          nextRewardMessage = '';
        }
      }
      const visibleProgress = builder.querySelector('.dt-pdp-bundle-builder__footer-progress');
      const visibleProgressWidth = visibleProgress && builder.clientWidth
        ? visibleProgress.getBoundingClientRect().width / builder.clientWidth * 100
        : null;

      const catalogKey = categories.map((category) => {
        return String(category.categoryId) + ':' + (category.products || []).map((product) => {
          return String(product.id || product.productId) + ':' + (product.variants || []).length;
        }).join(',');
      }).join('|');
      const shouldBuildCatalog = catalogKey !== renderedCatalogKey;
      const groups = shouldBuildCatalog ? categories.map((category) => {
        const selectedItems = getCategoryItems(category.categoryId);
        const limit = getCategoryLimit(category);
        const productCards = sortFreebiesProducts(category.products || []).map((product) => {
          const selectedItem = selectedItems.find((item) => String(item.product_id || item.productId) === String(product.id || product.productId));
          const variant = getProductVariant(product, selectedItem ? getItemVariantId(selectedItem) : '');
          if (!variant) return '';
          const variantId = String(variant.id || variant.variantId);
          const isSelected = selectedItems.some((item) => getItemVariantId(item) === variantId);
          const isFull = limit > 0 && selectedItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0) >= limit;
          const variants = product.variants || [];
          const swatches = variants.map((item) => {
            const id = String(item.id || item.variantId);
            const isAvailable = item.available !== false && item.availableForSale !== false;
            const label = item.title || item.public_title || 'Default';
            return '<button class="dt-pdp-bundle-builder__swatch" type="button" data-variant-id="' + escapeHtml(id) + '" aria-label="' + escapeHtml(label) + (isAvailable ? '' : ' - sold out') + '" aria-pressed="' + (id === variantId ? 'true' : 'false') + '"' + (isAvailable ? '' : ' disabled') + '><img src="' + escapeHtml(getProductImage(product, item)) + '" alt="" width="80" height="80" loading="lazy"></button>';
          }).join('');
          const price = Number(variant.price || product.price || 0);
          const specifications = isFreebies ? String(product.title || '').split('|').slice(1).map((part) => part.trim()).join(' · ') : '';
          const isUnavailable = !isSelected && isFull;
          return '<article class="dt-pdp-bundle-builder__product' + (isSelected ? ' is-selected' : '') + (isUnavailable ? ' is-unavailable' : '') + '"' + (isUnavailable ? ' aria-disabled="true"' : '') + ' data-category-id="' + escapeHtml(category.categoryId) + '" data-step-id="' + escapeHtml(category.stepId) + '" data-product-id="' + escapeHtml(product.id || product.productId) + '" data-variant-id="' + escapeHtml(variantId) + '">' +
            '<img class="dt-pdp-bundle-builder__image" src="' + escapeHtml(getProductImage(product, variant)) + '" alt="" width="312" height="312" loading="lazy">' +
            '<div class="dt-pdp-bundle-builder__content">' +
              '<h4 class="dt-pdp-bundle-builder__name">' + escapeHtml(getCardTitle(product)) + '</h4>' +
              (specifications ? '<p class="dt-freebies-product-specs">' + escapeHtml(specifications) + '</p>' : '') +
              '<p class="dt-pdp-bundle-builder__price">' + formatCardPrice(price) + '</p>' +
              '<div class="dt-pdp-bundle-builder__swatches" role="group" aria-label="Choose variant">' + swatches + '</div>' +
            '</div>' +
            '<button class="dt-pdp-bundle-builder__toggle' + (isSelected ? ' is-selected' : '') + '" type="button"' + (!isSelected && isFull ? ' disabled' : '') + '><span class="dt-pdp-bundle-builder__toggle-icon" aria-hidden="true">' + (isSelected ? '−' : '+') + '</span><span>' + (isSelected ? 'Remove' : 'Add') + '</span></button>' +
          '</article>';
        }).join('');
        return '<section class="dt-pdp-bundle-builder__group"><h4 class="dt-pdp-bundle-builder__group-title">' + escapeHtml(getCategoryHeading(category)) + '</h4><div class="dt-pdp-bundle-builder__products">' + productCards + '</div></section>';
      }).join('') : '';

      const validation = bundleInstance.f.validateBeforeAddBundleToCart({ showToast: false });
      const isReady = Boolean(validation?.ok) && (!isFreebies || (freebiesCheckoutEnabled && root.dataset.giftsReady === 'true'));
      if (isReady) prewarmCartRuntime().catch(() => {});
      const selectedUnits = cartItems
        .filter((item) => !isFreebies || !item.properties?._addon_product)
        .flatMap((item) => Array.from({ length: Number(item.quantity || 1) }, () => item));
      if (!isFreebies) selectedUnits.splice(3);
      const selectedProducts = selectedUnits.map((item) => {
        const product = categories.flatMap((category) => category.products || []).find((entry) => String(entry.id || entry.productId) === String(item.product_id || item.productId));
        const variant = bundleInstance.f.getVariantDataById(getItemVariantId(item)) || getProductVariant(product, getItemVariantId(item));
        const image = item.image || variant?.image || variant?.featured_image?.src || getProductImage(product, variant);
        return {
          imageUrl: isFreebies && item.properties?._addon_product ? assetUrls.gift : (typeof image === 'string' ? image : image?.src || ''),
          price: item.properties?._addon_product ? 0 : Number(variant?.price || product?.price || item.price || 0),
          isGift: Boolean(item.properties?._addon_product),
          title: isFreebies && item.properties?._addon_product ? getGiftTitle(getItemVariantId(item)) : (getCardTitle(product) || item.product_title || item.productTitle || item.title || 'Selected product'),
          uniqueKey: item?.properties?._uniqueGbbSdkItemKey || ''
        };
      });
      if (isFreebies && unlockedTier) selectedProducts.push(...getFreeGiftItems(unlockedTier));
      const selectedRows = selectedProducts.map(({ imageUrl, price, title, color, uniqueKey, isGift }) => {
        return '<div class="dt-pdp-bundle-builder__selected-row">' +
          '<div class="dt-pdp-bundle-builder__selected-product">' +
          '<img class="dt-pdp-bundle-builder__selected-image" src="' + escapeHtml(imageUrl || assetUrls.emptySlot) + '" alt="" width="32" height="32">' +
            '<div class="dt-pdp-bundle-builder__selected-details"><span class="dt-pdp-bundle-builder__selected-title">' + escapeHtml(title + (color ? ' · ' + color : '')) + '</span><span class="dt-pdp-bundle-builder__selected-price' + (isGift ? ' dt-gift-bundle__item-price--free' : '') + '">' + (isGift ? 'FREE' : formatCardPrice(price)) + '</span>' + (isGift ? '<span class="dt-pdp-bundle-builder__selected-note">Color might vary based on availability.</span>' : '') + '</div>' +
          '</div>' +
          (isGift ? '' : '<button class="dt-pdp-bundle-builder__selected-remove" type="button" data-item-key="' + escapeHtml(uniqueKey) + '" aria-label="Remove ' + escapeHtml(title) + '"><img src="' + escapeHtml(assetUrls.delete) + '" alt="" width="20" height="20"></button>') +
        '</div>';
      }).join('');
      const selectionSlots = [0, 1, 2].map((index) => {
        const selectedProduct = selectedProducts[index];
        if (!selectedProduct) {
          return '<span class="dt-pdp-bundle-builder__selection-slot is-empty"><img src="' + escapeHtml(assetUrls.emptySlot) + '" alt="" width="31" height="20"></span>';
        }
        return '<span class="dt-pdp-bundle-builder__selection-slot is-filled">' + (selectedProduct.imageUrl ? '<img src="' + escapeHtml(selectedProduct.imageUrl) + '" alt="" width="40" height="40">' : '') + '</span>';
      }).join('');
      const savingsAmount = Math.max(0, selectedProducts.reduce((sum, product) => sum + product.price, 0) - bundlePrice);
      const savings = !isFreebies && isReady && savingsAmount > 0
        ? '<div class="dt-pdp-bundle-builder__savings">You save ₹<strong>' + Math.round(savingsAmount / 100) + '</strong>&nbsp;on this bundle</div>'
        : '';
      const progressWidth = isFreebies ? rewardProgress : Math.min(100, selectedCount / 3 * 100);
      const previousTier = builder.querySelector('.dt-pdp-bundle-builder__footer')?.dataset.rewardTier;
      const tierChanged = isFreebies && previousTier !== undefined && Number(previousTier) !== unlockedTier;
      const initialProgressWidth = tierChanged ? 0 : (visibleProgressWidth === null ? progressWidth : visibleProgressWidth);
      const displayedSelectedCount = isFreebies ? selectedProducts.length : selectedCount;
      const selectionButton = '<button class="dt-pdp-bundle-builder__selection" type="button" data-selected-count="' + displayedSelectedCount + '" aria-label="' + (isFooterExpanded ? 'Hide' : 'Show') + ' ' + displayedSelectedCount + ' selected products" aria-expanded="' + isFooterExpanded + '" aria-controls="dt-pdp-bundle-selected-' + escapeHtml(sectionId) + '">' +
        (isFreebies ? '<span>' + displayedSelectedCount + ' Product' + (displayedSelectedCount === 1 ? '' : 's') + ' Added</span>' : '') +
        '<span class="dt-pdp-bundle-builder__selection-chevron" aria-hidden="true"><img src="' + escapeHtml(assetUrls.chevron) + '" alt="" width="20" height="20"></span>' + (isFreebies ? '' : selectionSlots) + '</button>';
      const rewardHeader = isFreebies ? '<div class="dt-freebies-footer-heading"><div class="dt-freebies-reward' + (nextRewardMessage ? ' is-rotating' : '') + '" aria-live="polite"><span>' + rewardMessage + '</span>' + (nextRewardMessage ? '<span>' + nextRewardMessage + '</span>' : '') + '</div>' + selectionButton + '</div>' : '';
      const footer = '<div class="dt-pdp-bundle-builder__footer' + (isFooterExpanded ? ' is-expanded' : '') + (savings ? ' has-savings' : '') + '" data-reward-tier="' + unlockedTier + '">' +
        '<img class="dt-pdp-bundle-builder__footer-progress" src="' + escapeHtml(assetUrls.progress) + '" alt="" style="width:' + initialProgressWidth + '%">' +
        savings + rewardHeader +
        '<div class="dt-pdp-bundle-builder__selected-wrap" id="dt-pdp-bundle-selected-' + escapeHtml(sectionId) + '"><div class="dt-pdp-bundle-builder__selected-clip"><div class="dt-pdp-bundle-builder__selected-list">' + selectedRows + '</div></div></div>' +
        '<div class="dt-pdp-bundle-builder__footer-row">' +
          (isFreebies ? '' : selectionButton) +
          '<button class="dt-pdp-bundle-builder__submit" type="button"' + (isReady ? '' : ' disabled') + '><span class="dt-pdp-bundle-builder__submit-label">Add Bundle To Cart</span><span class="dt-pdp-bundle-builder__submit-price">' + formatRupees(payableTotal) + '</span><span class="dt-pdp-bundle-builder__submit-status" aria-hidden="true"><span>Preparing your bundle</span><span>Checking your selections</span><span>Adding to cart</span></span></button>' +
        '</div>' +
        '<span class="dt-pdp-bundle-builder__footer-message" data-dt-bundle-message aria-live="polite">' + (isFreebies ? '' : (isReady ? 'Your bundle is ready' : selectedCount + ' of 3 products selected')) + '</span>' +
      '</div>';
      if (shouldBuildCatalog) {
        const deferredGroupMarker = mode === 'page' && categories.length < allCategories.length
          ? '<div class="dt-pdp-bundle-builder__deferred-group" data-dt-bundle-next-group aria-hidden="true"></div>'
          : '';
        builder.innerHTML = groups + deferredGroupMarker + footer;
        renderedCatalogKey = catalogKey;
      } else {
        updateProductCards(categories);
        const existingFooter = builder.querySelector('.dt-pdp-bundle-builder__footer');
        if (existingFooter) existingFooter.outerHTML = footer;
      }
      const progressBar = builder.querySelector('.dt-pdp-bundle-builder__footer-progress');
      if (progressBar && initialProgressWidth !== progressWidth) {
        progressBar.getBoundingClientRect();
        requestAnimationFrame(() => { progressBar.style.width = progressWidth + '%'; });
      }
      updateBundleSlots(cartItems);
    };

    const setFooterExpanded = (expanded) => {
      isFooterExpanded = Boolean(expanded);
      const footer = builder?.querySelector('.dt-pdp-bundle-builder__footer');
      const toggle = footer?.querySelector('.dt-pdp-bundle-builder__selection');
      if (!footer || !toggle) return;
      const selectedCount = Number(toggle.dataset.selectedCount || 0);
      footer.classList.toggle('is-expanded', isFooterExpanded);
      toggle.setAttribute('aria-expanded', String(isFooterExpanded));
      toggle.setAttribute('aria-label', (isFooterExpanded ? 'Hide' : 'Show') + ' ' + selectedCount + ' selected products');
    };

    const updateBundleSlots = (items) => {
      const slots = root.querySelectorAll('.dt-pdp-bundle__slot');
      slots.forEach((slot, index) => {
        const item = items[index];
        const variant = item && bundleInstance ? bundleInstance.f.getVariantDataById(getItemVariantId(item)) : null;
        const image = item ? (item.image || variant?.image || variant?.featured_image?.src || '') : '';
        slot.classList.toggle('dt-pdp-bundle__slot--empty', !image);
        slot.innerHTML = image ? '<img src="' + escapeHtml(typeof image === 'string' ? image : image.src) + '" alt="" width="40" height="40">' : '';
      });
    };

    const fetchCategoryProducts = async (categoryIds) => {
      const requestedIds = new Set(categoryIds.map(String));
      let pending = getBundleCategories().filter((category) => {
        return requestedIds.has(String(category.categoryId)) && (category.hasNextPage || !category.initialDataReady);
      }).map((category) => category.categoryId);
      let attempts = 0;
      while (pending.length && attempts < 8) {
        attempts += 1;
        const result = await bundleInstance.f.fetchProducts(pending);
        pending = pending.filter((categoryId) => result?.[categoryId]?.hasNextPage);
      }
    };

    const fetchAllCategoryProducts = () => fetchCategoryProducts(getBundleCategories().map((category) => category.categoryId));

    const loadDeferredCategories = async () => {
      const categories = getBundleCategories();
      if (visibleCategoryCount >= categories.length) return;
      root.dataset.bundleCatalog = 'loading-more';
      try {
        await fetchCategoryProducts(categories.slice(visibleCategoryCount).map((category) => category.categoryId));
        visibleCategoryCount = categories.length;
        root.dataset.bundleCatalog = 'ready';
        renderBundleBuilder();
      } catch (error) {
        root.dataset.bundleCatalog = 'partial';
      }
    };

    const observeDeferredCategories = () => {
      const marker = builder?.querySelector('[data-dt-bundle-next-group]');
      if (!marker) return;
      const beginObserving = () => {
        if (!('IntersectionObserver' in window)) {
          loadDeferredCategories();
          return;
        }
        categoryRevealObserver?.disconnect();
        categoryRevealObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          categoryRevealObserver.disconnect();
          categoryRevealObserver = null;
          loadDeferredCategories();
        }, { rootMargin: '120px 0px' });
        categoryRevealObserver.observe(marker);
      };
      if (window.scrollY > 0) beginObserving();
      else window.addEventListener('scroll', beginObserving, { once: true, passive: true });
    };

    const revealBundleBuilder = () => {
      if (loading) loading.hidden = true;
      if (builder) builder.hidden = false;
      if (mode === 'page') root.dispatchEvent(new CustomEvent('dt:bundle-builder-ready', { bubbles: true }));
    };

    const ensureBundleInstance = () => {
      if (instancePromise) return instancePromise;
      const startedAt = performance.now();
      instancePromise = waitForEasyBundleSdk()
        .then(createBundleInstance)
        .then(async (instance) => {
          if (!instance) throw new Error('Bundle not found');
          bundleInstance = instance;
          root.dataset.easyBundleSdk = 'ready';
          clearPageSelection();
          if (mode === 'page') {
            root.dataset.bundleCatalog = 'loading';
            const firstCategory = getBundleCategories()[0];
            if (!firstCategory) throw new Error('Bundle products could not be loaded');
            const firstCategoryReady = (firstCategory.products || []).some((product) => Boolean(getProductVariant(product, '')));
            if (!firstCategoryReady || (isFreebies && firstCategory.hasNextPage)) await fetchCategoryProducts([firstCategory.categoryId]);
            if (!(firstCategory.products || []).some((product) => Boolean(getProductVariant(product, '')))) {
              throw new Error('Bundle products could not be loaded');
            }
            root.dataset.bundleCatalog = getBundleCategories().length > 1 ? 'partial' : 'ready';
            renderBundleBuilder();
            revealBundleBuilder();
            observeDeferredCategories();
            const loadTime = Math.round(performance.now() - startedAt);
            root.dataset.bundleOpenMs = String(loadTime);
            root.dataset.bundlePerformance = loadTime <= loadBudgetMs ? 'within-budget' : 'over-budget';
          } else {
            await fetchAllCategoryProducts();
            if (!hasPrefilledCurrentProduct) syncCurrentProductVariant();
            syncedVariantId = getCurrentVariantId();
            revealBundleBuilder();
            renderBundleBuilder();
            const loadTime = Math.round(performance.now() - startedAt);
            root.dataset.bundleOpenMs = String(loadTime);
            root.dataset.bundlePerformance = loadTime <= loadBudgetMs ? 'within-budget' : 'over-budget';
          }
          return instance;
        })
        .catch((error) => {
          sharedRuntime.sdkReady = null;
          instancePromise = null;
          root.dataset.easyBundleSdk = 'error';
          root.dataset.bundleError = String(error?.message || error || 'Unknown bundle error');
          root.dataset.bundlePerformance = 'failed';
          if (loading) loading.hidden = true;
          if (builder) {
            builder.hidden = false;
            builder.innerHTML = '<div class="dt-pdp-bundle-builder__error"><div><p>We could not load the bundle here.</p><a class="dt-pdp-bundle-builder__fallback" href="' + escapeHtml(offerUrl) + '">Open bundle page</a></div></div>';
          }
          if (mode === 'page') root.dispatchEvent(new CustomEvent('dt:bundle-builder-error', { bubbles: true }));
          throw error;
        });
      return instancePromise;
    };

    const loadBundleBuilder = async () => {
      if (!frameWrap) return;
      await ensureBundleInstance().catch(() => {});
    };

    const wait = (delay) => new Promise((resolve) => window.setTimeout(resolve, delay));

    const prewarmCartRuntime = () => {
      if (!window.dtLoadCartRuntime) return Promise.resolve();
      if (!cartRuntimePromise) {
        cartRuntimePromise = Promise.resolve(window.dtLoadCartRuntime({ reason: 'pdp-bundle-ready' }))
          .catch((error) => {
            cartRuntimePromise = null;
            throw error;
          });
      }
      return cartRuntimePromise;
    };

    const clearPendingCartDrawer = () => {
      if (pendingDrawerTimer) {
        window.clearTimeout(pendingDrawerTimer);
        pendingDrawerTimer = null;
      }
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-pending-add');
      document.querySelectorAll('[data-pending-add-row]').forEach((row) => row.remove());
      if (window.CartController && typeof window.CartController.removePendingAddedItem === 'function') {
        window.CartController.removePendingAddedItem();
      }
    };

    const getGiftTitle = () => 'Banana Super Light Weight Terry Towel';

    const getPendingBundleSnapshot = () => {
      const categories = getBundleCategories();
      const cartItems = bundleInstance.f.getCartItems({ mergeBogo: true });
      const giftItem = isFreebies ? cartItems.find((item) => item.properties?._addon_product) : null;
      const selectedUnits = isFreebies ? cartItems.filter((item) => !item.properties?._addon_product) : cartItems
        .flatMap((item) => Array.from({ length: Number(item.quantity || 1) }, () => item)).slice(0, 3);
      const items = selectedUnits.map((item) => {
        const product = categories.flatMap((category) => category.products || [])
          .find((entry) => String(entry.id || entry.productId) === String(item.product_id || item.productId));
        const variant = bundleInstance.f.getVariantDataById(getItemVariantId(item)) || getProductVariant(product, getItemVariantId(item));
        const image = item.image || variant?.image || variant?.featured_image?.src || getProductImage(product, variant);
        return {
          image: typeof image === 'string' ? image : image?.src || '',
          title: ((getCardTitle(product) || item.product_title || item.productTitle || item.title || 'Selected product') + (isFreebies && variant?.title && variant.title !== 'Default Title' && variant.title !== product?.title ? ' · ' + variant.title : '')),
          quantity: isFreebies ? Number(item.quantity || 1) : 1,
          price: Number(item.price || variant?.price || 0) * (isFreebies ? Number(item.quantity || 1) : 1),
          isGift: Boolean(item.properties?._addon_product),
          variantId: getItemVariantId(item)
        };
      });
      const giftCount = getFreeGiftCount(getItemVariantId(giftItem));
      if (isFreebies && giftCount) items.push(...getFreeGiftItems(giftCount).map((item) => ({ ...item, image: item.imageUrl, quantity: 1, variantId: '' })));
      const tier = { '54874685571285': [149900, 129900], '54874703790293': [249900, 259900], '54874707165397': [399900, 389900] }[String(getItemVariantId(giftItem))];
      const total = isFreebies ? items.filter((item) => !item.isGift).reduce((sum, item) => sum + item.price, 0) : bundlePrice;
      return {
        isFreebies,
        originalPrice: tier ? formatCardPrice(total + tier[1]) : '',
        title: isFreebies ? 'Free bath towels' : bundleOfferName,
        note: isFreebies ? 'Color might vary based on availability.' : '',
        url: offerUrl,
        image: isFreebies ? items.find((item) => item.isGift)?.image || '' : offerImage,
        price: formatCardPrice(total),
        items
      };
    };

    const renderPendingBundleItem = (bundle) => {
      const contents = document.querySelector('cart-drawer #CartDrawer-CartItems');
      if (!contents || contents.querySelector('[data-pending-add-row]')) return;
      let tbody = contents.querySelector('tbody');
      if (!tbody) {
        contents.insertAdjacentHTML('afterbegin', '<div class="drawer__cart-items-wrapper"><table class="cart-items" role="table"><tbody role="rowgroup"></tbody></table></div>');
        tbody = contents.querySelector('tbody');
      }
      if (!tbody) return;

      if (bundle.isFreebies) {
        const rows = bundle.items.map((item) => '<div class="dt-gift-bundle__item">' +
          '<img class="dt-gift-bundle__item-image" src="' + escapeHtml(item.isGift ? assetUrls.gift : item.image) + '" alt="" width="48" height="48">' +
          '<span class="dt-gift-bundle__item-title">' + escapeHtml(item.title) + (item.quantity > 1 ? ' × ' + item.quantity : '') + '</span>' +
          '<span class="dt-gift-bundle__item-price' + (item.isGift ? ' dt-gift-bundle__item-price--free' : '') + '">' + (item.isGift ? 'Free' : formatCardPrice(item.price)) + '</span></div>').join('');
        tbody.insertAdjacentHTML('afterbegin', '<tr class="cart-item dt-gift-bundle-row" data-pending-add-row aria-busy="true"><td colspan="3"><div class="dt-gift-bundle">' +
          '<div class="dt-gift-bundle__banner" aria-hidden="true"><svg viewBox="0 0 16 16" width="16" height="16" fill="none"><path d="M3 7.25h10v6.25H3V7.25Zm5 0v6.25M2.25 4.75h11.5v2.5H2.25v-2.5ZM8 4.75C5.3 4.75 4.3 3.8 4.3 2.9c0-.7.55-1.15 1.25-1.15C6.75 1.75 8 4.75 8 4.75Zm0 0c2.7 0 3.7-.95 3.7-1.85 0-.7-.55-1.15-1.25-1.15C9.25 1.75 8 4.75 8 4.75Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg><span>Free gift included</span></div>' +
          '<div class="dt-gift-bundle__offer"><div class="dt-gift-bundle__summary">' +
          (bundle.image ? '<img class="dt-gift-bundle__offer-image" src="' + escapeHtml(bundle.image) + '" alt="" width="40" height="40">' : '<span class="dt-gift-bundle__offer-image"></span>') +
          '<div class="dt-gift-bundle__copy"><p class="dt-gift-bundle__title">' + escapeHtml(bundle.title) + '</p>' + (bundle.note ? '<p class="dt-gift-bundle__note">' + escapeHtml(bundle.note) + '</p>' : '') + '</div><div class="dt-gift-bundle__price"><span>' + escapeHtml(bundle.price) + '</span><s>' + escapeHtml(bundle.originalPrice) + '</s></div></div>' +
          '<div class="dt-gift-bundle__actions"><details class="dt-gift-bundle__details"><summary><span>View ' + bundle.items.reduce((sum, item) => sum + item.quantity, 0) + ' products</span><svg viewBox="0 0 20 20" width="20" height="20" fill="none" aria-hidden="true"><path d="m7.5 5 5 5-5 5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/></svg></summary><div class="dt-gift-bundle__items">' + rows + '</div></details>' +
          '<cart-remove-button><button type="button" class="dt-gift-bundle__remove" disabled aria-label="Adding bundle"><svg width="12" height="13" viewBox="0 0 12 13" fill="none"><path d="m8.5 9.3-5.7-5.7m.1 5.7 5.7-5.7" stroke="currentColor" stroke-linecap="round"/></svg></button></cart-remove-button></div></div></div></td></tr>');
        return;
      }

      const itemRows = bundle.items.map((item) => '<li class="dt-cart-bundle__item">' +
        (item.image ? '<img class="dt-cart-bundle__item-media" src="' + escapeHtml(item.image) + '" alt="" width="32" height="32">' : '') +
        '<span class="dt-cart-bundle__item-title">' + escapeHtml(item.title) + '</span></li>').join('');
      tbody.insertAdjacentHTML('afterbegin',
        '<tr class="cart-item cart-item--easybundle-parent cart-item--pending-add" role="row" data-pending-add-row aria-busy="true">' +
          '<td class="cart-item__media" role="cell"><a href="' + escapeHtml(bundle.url) + '" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a>' +
            '<img class="cart-item__image cart-item__image--easybundle-offer" src="' + escapeHtml(bundle.image) + '" alt="' + escapeHtml(bundle.title) + '" width="112" height="112"></td>' +
          '<td class="cart-item__details" role="cell"><a href="' + escapeHtml(bundle.url) + '" class="cart-item__name h4">' + escapeHtml(bundle.title) + '</a>' +
            '<p class="dt-cart-easybundle__meta">' + bundle.items.length + ' products selected</p>' +
            '<details class="dt-cart-bundle dt-cart-easybundle"><summary><span>View bundle</span><svg aria-hidden="true" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></summary>' +
              '<div class="dt-cart-bundle__reveal"><ol class="dt-cart-bundle__items">' + itemRows + '</ol></div></details></td>' +
          '<td class="cart-item__quantity" role="cell"><div class="cart-item__price-wrapper-inline"><span class="price light-text cart-item__final-price">' + escapeHtml(bundle.price) + '</span></div>' +
            '<quantity-popover><div class="cart-item__quantity-wrapper quantity-popover-wrapper"><cart-remove-button><button type="button" class="button button--tertiary cart-remove-button" disabled aria-hidden="true"><svg aria-hidden="true" focusable="false" width="12" height="13" class="icon icon-close-small" viewBox="0 0 12 13" fill="none"><path d="M8.48627 9.32917L2.82849 3.67098" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.88539 9.38504L8.42932 3.61524" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></cart-remove-button></div></quantity-popover></td>' +
        '</tr>');
    };

    const schedulePendingCartDrawer = (snapshot) => new Promise((resolve) => {
      pendingDrawerTimer = window.setTimeout(() => {
        pendingDrawerTimer = null;
        if (!cartDrawerPending) {
          resolve();
          return;
        }

        if (mode === 'pdp') closeSheet({ restoreFocus: false });
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.add('is-pending-add');
        pendingDrawerOpened = true;
        renderPendingBundleItem(snapshot);

        if (window.CartController) {
          window.CartController.prepareOptimisticDrawerSurface?.();
          window.CartController.openDrawer?.({ skipRefresh: true, force: true });
        } else if (drawer) {
          drawer.classList.add('active', 'animate');
        }

        prewarmCartRuntime()
          .catch(() => {})
          .then(() => {
            if (!cartDrawerPending) return;
            if (window.CartController) {
              window.CartController.prepareOptimisticDrawerSurface?.();
              renderPendingBundleItem(snapshot);
              if (!document.querySelector('cart-drawer')?.classList.contains('active')) {
                window.CartController.openDrawer?.({ skipRefresh: true, force: true });
              }
            }
          });
        resolve();
      }, 2000);
    });

    const openCartDrawer = async (options = {}) => {
      await prewarmCartRuntime().catch(() => {});

      if (options.skipRefresh && window.CartController && typeof window.CartController.openDrawer === 'function') {
        window.CartController.openDrawer({ skipRefresh: true, force: true });
        return;
      }

      if (window.CartController && typeof window.CartController.finishAddToCartRefresh === 'function') {
        try {
          await window.CartController.finishAddToCartRefresh({
            refreshRecommendations: true,
            refreshItems: true,
            refreshCartPage: false,
            deferRecommendations: true
          });
          if (typeof window.CartController.openDrawer === 'function') {
            const drawer = document.querySelector('cart-drawer');
            if (!drawer?.classList.contains('active')) {
              window.CartController.openDrawer({ skipRefresh: true });
            }
            await wait(80);
            if (document.querySelector('cart-drawer')?.classList.contains('active')) return;
          }
        } catch (error) {}
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.refreshSections === 'function') drawer.refreshSections();
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else if (drawer) {
        drawer.classList.add('active', 'animate');
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }

      try {
        const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((response) => response.json());
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      } catch (error) {}
    };

    const escapeHtml = (value) => String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    const stripHtml = (value) => {
      const element = document.createElement('div');
      element.innerHTML = String(value || '');
      return (element.textContent || '').replace(/\s+/g, ' ').trim();
    };

    const addProductImage = (images, value) => {
      if (!value) return;
      if (Array.isArray(value)) {
        value.forEach((item) => addProductImage(images, item));
        return;
      }
      if (typeof value === 'string') {
        images.push(value);
        return;
      }
      addProductImage(images, value.src || value.url || value.originalSrc || value.transformedSrc || value.preview_image?.src || value.image);
    };

    const normalizeProductImage = (value) => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        const filename = decodeURIComponent(url.pathname.split('/').pop() || url.pathname);
        return filename.replace(/_\d+x\d+(?:_crop_[^.]*)?(?=\.[^.]+$)/i, '').toLowerCase();
      } catch (error) {
        return String(value || '').split('?')[0].split('/').pop().replace(/_\d+x\d+(?:_crop_[^.]*)?(?=\.[^.]+$)/i, '').toLowerCase();
      }
    };

    const getProductImages = (product, variant) => {
      const images = [];
      addProductImage(images, product?._pdpImages);
      if (!images.length) {
        addProductImage(images, product?.images);
        addProductImage(images, product?.media);
        addProductImage(images, product?.image);
        addProductImage(images, product?.featuredImage);
        addProductImage(images, product?.featured_image);
      }
      if (!images.length) {
        (product?.variants || []).forEach((item) => {
          addProductImage(images, item.image);
          addProductImage(images, item.featured_image);
        });
      }
      const seen = new Set();
      const uniqueImages = images.filter(Boolean).filter((image) => {
        const key = normalizeProductImage(image);
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      const variantImage = getProductImage(product, variant);
      const variantImageKey = normalizeProductImage(variantImage);
      const variantIndex = uniqueImages.findIndex((image) => normalizeProductImage(image) === variantImageKey);
      if (product?._pdpImages?.length && variantIndex > -1) {
        const otherVariantImages = new Set((product.variants || []).filter((item) => {
          return String(item.id || item.variantId) !== String(variant?.id || variant?.variantId);
        }).map((item) => normalizeProductImage(getProductImage(product, item))).filter(Boolean));
        let variantEnd = variantIndex + 1;
        while (variantEnd < uniqueImages.length && !otherVariantImages.has(normalizeProductImage(uniqueImages[variantEnd]))) variantEnd += 1;
        return uniqueImages.slice(variantIndex, variantEnd).slice(0, 8);
      }
      const variantToken = getVariantLabel(variant).replace(/[^a-z0-9]/gi, '').toLowerCase();
      const variantImages = !variantToken ? [] : uniqueImages.filter((image) => {
        return normalizeProductImage(image).replace(/[^a-z0-9]/gi, '').includes(variantToken);
      });
      const sequencedImages = variantImages.length > 1 ? variantImages : uniqueImages;
      const sequencedVariantIndex = sequencedImages.findIndex((image) => normalizeProductImage(image) === variantImageKey);
      const orderedImages = sequencedVariantIndex > 0
        ? sequencedImages.slice(sequencedVariantIndex).concat(sequencedImages.slice(0, sequencedVariantIndex))
        : sequencedImages;
      return orderedImages.slice(0, 8);
    };

    const getProductFromCard = (card) => {
      const category = getBundleCategories().find((entry) => String(entry.categoryId) === String(card?.dataset.categoryId));
      const product = category?.products?.find((entry) => String(entry.id || entry.productId) === String(card?.dataset.productId));
      return { category, product };
    };

    const getVariantLabel = (variant) => {
      const option = Array.isArray(variant?.options) ? variant.options[0] : '';
      const label = option || variant?.title || variant?.public_title || 'Default';
      return String(label).replace(/^Default Title$/i, 'Default');
    };

    const getProductRating = (product) => {
      const value = product?.rating?.value ?? product?.rating ?? product?.reviews?.rating ?? 4.9;
      const rating = Number(value);
      return Number.isFinite(rating) ? Math.min(5, Math.max(0, rating)) : 4.9;
    };

    const getDetailText = (node) => {
      if (!node) return '';
      const rows = Array.from(node.querySelectorAll('.dt-pdp-ab__detail-row'));
      if (rows.length) {
        return rows.map((row) => {
          const term = row.querySelector('dt')?.textContent?.trim() || '';
          const value = row.querySelector('dd')?.textContent?.trim() || '';
          return [term, value].filter(Boolean).join(': ');
        }).filter(Boolean).join('\n');
      }
      const blocks = Array.from(node.children || []).map((child) => (child.textContent || '').replace(/\s+/g, ' ').trim()).filter(Boolean);
      return (blocks.length ? blocks.join('\n\n') : node.textContent || '').trim();
    };

    const getPdpDetails = (documentRoot) => {
      const details = {};
      Array.from(documentRoot.querySelectorAll('.dt-pdp-ab__detail-item')).forEach((item) => {
        const label = item.querySelector('.dt-pdp-ab__detail-link span:last-child')?.textContent?.replace(/\s+/g, ' ').trim();
        if (!label) return;
        const content = item.querySelector('.dt-pdp-ab__detail-content');
        if (content) details[label] = getDetailText(content);
      });
      const usageTemplate = documentRoot.querySelector('template[data-detail-sheet-template="Usage & Care"]');
      if (usageTemplate) details['Usage & Care'] = getDetailText(usageTemplate.content || usageTemplate);

      if (!Object.keys(details).length) {
        Array.from(documentRoot.querySelectorAll('.product__accordion')).forEach((item) => {
          const label = item.querySelector('summary')?.textContent?.replace(/\s+/g, ' ').trim();
          const content = item.querySelector('.accordion__content');
          if (label && content) details[label] = getDetailText(content);
        });
      }
      return details;
    };

    const fetchProductDetails = (product) => {
      const rawHandle = product?.handle || String(product?.url || product?.onlineStoreUrl || '').split('/products/')[1]?.split(/[?#]/)[0];
      const handle = String(rawHandle || '').trim();
      if (!handle) return Promise.resolve(null);
      if (productDetailsCache.has(handle)) return productDetailsCache.get(handle);
      const rootPath = window.Shopify?.routes?.root || '/';
      const request = fetch(rootPath + 'products/' + encodeURIComponent(handle), { credentials: 'same-origin' })
        .then((response) => response.ok ? response.text() : '')
        .then((html) => {
          if (!html) return null;
          const documentRoot = new DOMParser().parseFromString(html, 'text/html');
          const images = Array.from(documentRoot.querySelectorAll('.dt-pdp-ab__slide > img, media-gallery .product__media img'))
            .map((image) => image.getAttribute('src') || image.getAttribute('data-src') || '')
            .filter(Boolean)
            .map((image) => {
              try { return new URL(image, window.location.origin).href; } catch (error) { return image; }
            });
          return {
            images,
            details: getPdpDetails(documentRoot),
            description: documentRoot.querySelector('meta[name="description"]')?.content || ''
          };
        })
        .catch(() => null);
      productDetailsCache.set(handle, request);
      return request;
    };

    const ensureProductDetailsSheet = () => {
      if (productDetailsSheet) return productDetailsSheet;
      productDetailsSheet = document.createElement('div');
      productDetailsSheet.className = 'dt-pdp-bundle-product-sheet' + (isFreebies ? ' dt-freebies-product-sheet' : '');
      productDetailsSheet.hidden = true;
      productDetailsSheet.setAttribute('aria-hidden', 'true');
      productDetailsSheet.innerHTML = '<button class="dt-pdp-bundle-product-sheet__scrim" type="button" data-dt-product-details-close aria-label="Back to bundle"></button>' +
        '<section class="dt-pdp-bundle-product-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="DtBundleProductTitle-' + escapeHtml(sectionId) + '">' +
          '<div class="dt-pdp-bundle-product-sheet__scroll" data-dt-product-details-body></div>' +
          '<div class="dt-pdp-bundle-product-sheet__cta-wrap"><button class="dt-pdp-bundle-product-sheet__cta" type="button" data-dt-product-details-add>Add to Bundle</button></div>' +
        '</section>';
      document.body.appendChild(productDetailsSheet);

      productDetailsSheet.addEventListener('click', (event) => {
        if (event.target.closest('[data-dt-product-details-close]')) {
          closeProductDetails();
          return;
        }

        const variantButton = event.target.closest('[data-dt-product-detail-variant]');
        if (variantButton && productDetailsProduct) {
          productDetailsVariantId = String(variantButton.dataset.dtProductDetailVariant || '');
          renderProductDetails();
          return;
        }

        const detailButton = event.target.closest('[data-dt-product-detail-toggle]');
        if (detailButton) {
          const expanded = detailButton.getAttribute('aria-expanded') === 'true';
          detailButton.setAttribute('aria-expanded', String(!expanded));
          return;
        }

        if (event.target.closest('[data-dt-product-details-add]')) addProductDetailsSelection();
      });
      return productDetailsSheet;
    };

    const productDetailRows = (product, variant) => {
      const pageDetails = product?._pdpDetails || {};
      const description = stripHtml(product?.descriptionHtml || product?.description || product?.body_html || '');
      const specifications = stripHtml(product?.specs || product?.specifications || '');
      const usageCare = stripHtml(product?.usageCare || product?.usage_care || specifications || 'Please follow the care instructions on the product label.');
      const specificationCopy = [description, specifications].filter(Boolean).join('\n\n') || 'Product specifications are shown on the product label.';
      const detailsCopy = 'MRP (inclusive of all taxes): ' + formatCardPrice(variant?.price || product?.price || 0) + '\n\nManufacturer: Doctor Safe Towels Factory Pvt. Ltd\n2B, IV Street, Ramakrishnapuram, Karur - 639001, Tamil Nadu, India.\nCountry of Origin: India\nPhone: +91 80698 35407\nEmail: customercare@doctortowels.com';
      return [
        { title: 'Specifications', icon: assetUrls.specifications, content: pageDetails.Specifications || specificationCopy },
        { title: 'Product Details', icon: assetUrls.productDetails, content: pageDetails['Product Details'] || detailsCopy },
        { title: 'Usage & Care', icon: assetUrls.usageCare, content: pageDetails['Usage & Care'] || usageCare },
        { title: 'Disclaimer', icon: assetUrls.disclaimer, content: pageDetails.Disclaimer || 'Designed to help reduce bacterial growth on its surface, this towel supports everyday hygiene and helps protect sensitive skin. Regular washing and proper care will help it perform at its best. Results may vary with use and individual skin sensitivity.' }
      ];
    };

    const renderProductDetails = () => {
      if (!productDetailsSheet || !productDetailsProduct) return;
      const body = productDetailsSheet.querySelector('[data-dt-product-details-body]');
      const cta = productDetailsSheet.querySelector('[data-dt-product-details-add]');
      const product = productDetailsProduct;
      const variants = product.variants || [];
      const variant = getProductVariant(product, productDetailsVariantId) || variants[0] || null;
      if (variant) productDetailsVariantId = String(variant.id || variant.variantId || '');
      const images = getProductImages(product, variant);
      const title = getCardTitle(product) || product.title || 'Product';
      const rating = getProductRating(product);
      const filledStars = Math.round(rating);
      const stars = Array.from({ length: 5 }, (_, index) => '<img src="' + (index < filledStars ? assetUrls.starFilled : assetUrls.starEmpty) + '" alt="" width="16" height="16">').join('');
      const gallery = (images.length ? images : [getProductImage(product, variant)]).filter(Boolean).map((image, index) => '<img class="dt-pdp-bundle-product-sheet__gallery-image" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" width="334" height="400" loading="' + (index ? 'lazy' : 'eager') + '"' + (index ? '' : ' fetchpriority="high"') + '>').join('');
      const variantCards = variants.map((item) => {
        const id = String(item.id || item.variantId || '');
        const selected = id === productDetailsVariantId;
        const available = item.available !== false && item.availableForSale !== false;
        const label = getVariantLabel(item);
        return '<button class="dt-pdp-bundle-product-sheet__variant" type="button" data-dt-product-detail-variant="' + escapeHtml(id) + '" aria-label="' + escapeHtml(label + (available ? '' : ' - sold out')) + '" aria-pressed="' + selected + '"' + (available ? '' : ' disabled') + '>' +
          '<img src="' + escapeHtml(getProductImage(product, item) || images[0] || '') + '" alt="" width="183" height="175" loading="lazy">' +
          (selected || !available ? '<span class="dt-pdp-bundle-product-sheet__variant-label">' + (selected ? 'Selected' : 'Sold out') + '</span>' : '') +
        '</button>';
      }).join('');
      const rows = productDetailRows(product, variant).map((row, index) => '<section class="dt-pdp-bundle-product-sheet__detail">' +
        '<button class="dt-pdp-bundle-product-sheet__detail-button" type="button" data-dt-product-detail-toggle aria-expanded="false" aria-controls="DtBundleProductDetail-' + escapeHtml(sectionId) + '-' + index + '">' +
          '<img class="dt-pdp-bundle-product-sheet__detail-icon" src="' + row.icon + '" alt="" width="20" height="20"><span>' + escapeHtml(row.title) + '</span><img class="dt-pdp-bundle-product-sheet__detail-chevron" src="' + escapeHtml(assetUrls.detailChevron) + '" alt="" width="16" height="16">' +
        '</button><div class="dt-pdp-bundle-product-sheet__detail-content" id="DtBundleProductDetail-' + escapeHtml(sectionId) + '-' + index + '"><div><p>' + escapeHtml(row.content) + '</p></div></div>' +
      '</section>').join('');
      body.innerHTML = '<div class="dt-pdp-bundle-product-sheet__gallery-wrap"><div class="dt-pdp-bundle-product-sheet__gallery">' + gallery + '</div><button class="dt-pdp-bundle-product-sheet__close" type="button" data-dt-product-details-close aria-label="Back to bundle"><img src="' + escapeHtml(assetUrls.productClose) + '" alt="" width="24" height="24"></button></div>' +
        '<div class="dt-pdp-bundle-product-sheet__summary"><div class="dt-pdp-bundle-product-sheet__heading-row"><h2 class="dt-pdp-bundle-product-sheet__title" id="DtBundleProductTitle-' + escapeHtml(sectionId) + '">' + escapeHtml(title) + '</h2><span class="dt-pdp-bundle-product-sheet__rating" aria-label="' + escapeHtml(rating.toFixed(1)) + ' out of 5 customer rating"><span class="dt-pdp-bundle-product-sheet__stars" aria-hidden="true">' + stars + '</span><span>' + escapeHtml(rating.toFixed(1)) + '</span></span></div><p class="dt-pdp-bundle-product-sheet__price">' + formatCardPrice(variant?.price || product.price || 0) + '</p></div>' +
        (variantCards ? '<div class="dt-pdp-bundle-product-sheet__variants"><p class="dt-pdp-bundle-product-sheet__variant-heading">Choose variant: <span>' + escapeHtml(getVariantLabel(variant)) + '</span></p><div class="dt-pdp-bundle-product-sheet__variant-list">' + variantCards + '</div></div>' : '') +
        '<div class="dt-pdp-bundle-product-sheet__details">' + rows + '</div>';
      if (cta) {
        const available = variant && variant.available !== false && variant.availableForSale !== false;
        cta.disabled = !available;
        cta.textContent = available ? 'Add to Bundle' : 'Sold out';
      }
    };

    const closeProductDetails = () => {
      if (!productDetailsSheet || productDetailsSheet.hidden) return;
      productDetailsSheet.classList.remove('is-open');
      productDetailsSheet.setAttribute('aria-hidden', 'true');
      if (productDetailsCloseTimer) window.clearTimeout(productDetailsCloseTimer);
      productDetailsCloseTimer = window.setTimeout(() => {
        productDetailsCloseTimer = null;
        if (productDetailsSheet.classList.contains('is-open')) return;
        productDetailsSheet.hidden = true;
        if (productDetailsPreviousFocus?.isConnected) productDetailsPreviousFocus.focus({ preventScroll: true });
      }, 240);
    };

    const openProductDetails = (card) => {
      const { product } = getProductFromCard(card);
      if (!product) return;
      ensureProductDetailsSheet();
      if (productDetailsCloseTimer) {
        window.clearTimeout(productDetailsCloseTimer);
        productDetailsCloseTimer = null;
      }
      productDetailsCard = card;
      productDetailsProduct = product;
      productDetailsVariantId = String(card.dataset.variantId || '');
      productDetailsPreviousFocus = document.activeElement;
      renderProductDetails();
      productDetailsSheet.hidden = false;
      productDetailsSheet.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        productDetailsSheet.classList.add('is-open');
        productDetailsSheet.querySelector('[data-dt-product-details-close]')?.focus({ preventScroll: true });
      });

      fetchProductDetails(product).then((details) => {
        if (!details || productDetailsProduct !== product || productDetailsSheet.hidden) return;
        if (!product.descriptionHtml && !product.description && details.description) product.description = details.description;
        if (details.images?.length) product._pdpImages = details.images;
        if (details.details) product._pdpDetails = details.details;
        renderProductDetails();
      });
    };

    const addProductDetailsSelection = () => {
      if (!bundleInstance || !productDetailsCard || !productDetailsProduct) return;
      const card = productDetailsCard;
      const selectedItem = getCategoryItems(card.dataset.categoryId).find((item) => String(item.product_id || item.productId) === String(card.dataset.productId));
      if (selectedItem && getItemVariantId(selectedItem) === productDetailsVariantId) {
        closeProductDetails();
        return;
      }
      if (selectedItem) {
        const uniqueId = selectedItem?.properties?._uniqueGbbSdkItemKey;
        if (uniqueId) bundleInstance.f.updateCartItem(uniqueId, { quantity: 0, showToast: false });
      }
      const result = bundleInstance.f.addProductToBundle({
        categoryId: card.dataset.categoryId,
        stepId: card.dataset.stepId,
        variantId: Number(productDetailsVariantId),
        quantity: 1,
        showToast: false
      });
      if (!result?.ok) {
        const message = builder.querySelector('[data-dt-bundle-message]');
        if (message) message.textContent = result?.data?.message || 'Choose a different product';
        return;
      }
      scheduleBundleRender();
      closeProductDetails();
    };

    const openSheet = () => {
      if (!sheet) return;
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      previousFocus = document.activeElement;
      trackBundle('click');
      prewarmCartRuntime().catch(() => {});
      sheet.removeAttribute('data-cart-drawer-hidden');
      sheet.style.removeProperty('display');
      sheet.style.removeProperty('pointer-events');
      sheet.hidden = false;
      sheet.setAttribute('aria-hidden', 'false');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      requestAnimationFrame(() => {
        sheet.classList.add('is-open');
        loadBundleBuilder();
        const nextFocus = sheet.querySelector('[data-dt-pdp-bundle-close]');
        if (nextFocus) nextFocus.focus({ preventScroll: true });
      });
      document.documentElement.classList.add('dt-pdp-bundle-sheet-open');
    };

    const closeSheet = (options = {}) => {
      if (!sheet) return;
      const restoreFocus = options.restoreFocus !== false;
      sheet.classList.remove('is-open');
      sheet.style.pointerEvents = 'none';
      sheet.setAttribute('aria-hidden', 'true');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.documentElement.classList.remove('dt-pdp-bundle-sheet-open');
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        closeTimer = null;
        if (sheet.getAttribute('aria-hidden') !== 'true' || sheet.classList.contains('is-open')) return;
        sheet.hidden = true;
        if (restoreFocus && previousFocus && typeof previousFocus.focus === 'function') {
          previousFocus.focus({ preventScroll: true });
        }
      }, 220);
    };

    if ('IntersectionObserver' in window) {
      const warmObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        warmObserver.disconnect();
        warmBundleBuilder();
      }, { rootMargin: '600px 0px' });
      warmObserver.observe(root);
    }
    root.addEventListener('pointerenter', warmBundleBuilder, { once: true, passive: true });
    root.addEventListener('focusin', warmBundleBuilder, { once: true });

    if (builder) {
      builder.addEventListener('click', async (event) => {
        const footerToggle = event.target.closest('.dt-pdp-bundle-builder__selection');
        if (footerToggle) {
          setFooterExpanded(!isFooterExpanded);
          return;
        }

        const selectedRemove = event.target.closest('.dt-pdp-bundle-builder__selected-remove');
        if (selectedRemove && bundleInstance) {
          const itemKey = selectedRemove.dataset.itemKey;
          if (itemKey) bundleInstance.f.updateCartItem(itemKey, { quantity: 0, showToast: false });
          scheduleBundleRender();
          return;
        }

        const swatch = event.target.closest('.dt-pdp-bundle-builder__swatch');
        if (swatch && bundleInstance) {
          const card = swatch.closest('.dt-pdp-bundle-builder__product');
          const category = getBundleCategories().find((entry) => entry.categoryId === card?.dataset.categoryId);
          const product = category?.products?.find((entry) => String(entry.id || entry.productId) === String(card?.dataset.productId));
          const variant = getProductVariant(product, swatch.dataset.variantId);
          if (!card || !variant) return;

          const selectedItem = getCategoryItems(card.dataset.categoryId).find((item) => String(item.product_id || item.productId) === String(card.dataset.productId));
          if (selectedItem) {
            const uniqueId = selectedItem?.properties?._uniqueGbbSdkItemKey;
            if (uniqueId) bundleInstance.f.updateCartItem(uniqueId, { quantity: 0, showToast: false });
            bundleInstance.f.addProductToBundle({
              categoryId: card.dataset.categoryId,
              stepId: card.dataset.stepId,
              variantId: Number(swatch.dataset.variantId),
              quantity: 1,
              showToast: false
            });
            scheduleBundleRender();
            return;
          }

          card.dataset.variantId = swatch.dataset.variantId;
          card.querySelectorAll('.dt-pdp-bundle-builder__swatch').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === swatch));
          });
          const image = card.querySelector('.dt-pdp-bundle-builder__image');
          const price = card.querySelector('.dt-pdp-bundle-builder__price');
          if (image) image.src = getProductImage(product, variant);
          if (price) price.textContent = formatCardPrice(variant.price || product?.price || 0);
          return;
        }

        const toggle = event.target.closest('.dt-pdp-bundle-builder__toggle');
        if (toggle && bundleInstance) {
          const card = toggle.closest('.dt-pdp-bundle-builder__product');
          const selectedItem = getCategoryItems(card.dataset.categoryId).find((item) => getItemVariantId(item) === String(card.dataset.variantId));
          let result;
          if (selectedItem) {
            result = bundleInstance.f.updateCartItem(selectedItem?.properties?._uniqueGbbSdkItemKey, { quantity: 0, showToast: false });
          } else {
            result = bundleInstance.f.addProductToBundle({
              categoryId: card.dataset.categoryId,
              stepId: card.dataset.stepId,
              variantId: Number(card.dataset.variantId),
              quantity: 1,
              showToast: false
            });
          }
          if (!result?.ok) {
            const message = builder.querySelector('[data-dt-bundle-message]');
            if (message) message.textContent = result?.data?.message || 'Choose a different product';
          }
          scheduleBundleRender();
          return;
        }

        const productCard = event.target.closest('.dt-pdp-bundle-builder__product');
        if (productCard) {
          openProductDetails(productCard);
          return;
        }

        const submit = event.target.closest('.dt-pdp-bundle-builder__submit');
        if (!submit || !bundleInstance || cartDrawerPending) return;
        if (isFreebies && !freebiesCheckoutEnabled) return;
        if (isFreebies && !syncFreebie()) {
          const message = builder.querySelector('[data-dt-bundle-message]');
          if (message) message.textContent = 'Your free gift is unavailable. Please try again.';
          return;
        }
        cartDrawerPending = true;
        submit.disabled = true;
        submit.classList.add('is-preparing');
        submit.setAttribute('aria-busy', 'true');
        submit.setAttribute('aria-label', 'Preparing your bundle');
        trackBundle('add_to_cart');
        const pendingDrawerPromise = schedulePendingCartDrawer(getPendingBundleSnapshot());
        let result;
        const cartTransformSetting = bundleInstance.bundleData.isCartTransformationAllowed;
        const keepPaidProducts = mode === 'page' && originHandle === 'freebies' && offerId === 'SDK-548269';
        // Keep paid products at their catalog identities; EasyBundles still attaches the eligible gift.
        if (keepPaidProducts) bundleInstance.bundleData.isCartTransformationAllowed = false;
        try {
          result = await bundleInstance.f.addBundleToCart({ showToast: false });
        } catch (error) {
          result = null;
        } finally {
          if (keepPaidProducts) bundleInstance.bundleData.isCartTransformationAllowed = cartTransformSetting;
        }
        if (result?.ok) {
          trackBundle('cart_added');
          if (mode === 'page') {
            clearPageSelection();
            renderBundleBuilder();
          }
          await pendingDrawerPromise;
          await openCartDrawer();
          clearPendingCartDrawer();
        } else {
          clearPendingCartDrawer();
          if (pendingDrawerOpened && mode === 'pdp') {
            window.CartController?.closeDrawer?.();
            pendingDrawerOpened = false;
            window.setTimeout(openSheet, 220);
          }
          submit.classList.remove('is-preparing');
          submit.removeAttribute('aria-busy');
          submit.removeAttribute('aria-label');
          const message = builder.querySelector('[data-dt-bundle-message]');
          if (message) message.textContent = result?.data?.message || 'Unable to add bundle';
          scheduleBundleRender();
        }
        pendingDrawerOpened = false;
        cartDrawerPending = false;
      });
    }

    document.addEventListener('pointerdown', (event) => {
      if (!isFooterExpanded) return;
      const footer = builder?.querySelector('.dt-pdp-bundle-builder__footer');
      if (!footer || footer.contains(event.target)) return;
      setFooterExpanded(false);
    }, { passive: true });

    root.addEventListener('click', (event) => {
      if (event.target.closest('[data-dt-pdp-bundle-open]')) openSheet();
    });

    const handleVariantChange = () => {
      window.setTimeout(() => {
        updateSavingCopy();
        if (bundleInstance && syncedVariantId !== getCurrentVariantId()) {
          syncCurrentProductVariant();
          syncedVariantId = getCurrentVariantId();
          scheduleBundleRender();
        }
      }, 60);
    };

    if (mode === 'pdp') document.addEventListener('change', handleVariantChange);
    if (mode === 'pdp' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data?.sectionId || '') !== sectionId) return;
        window.setTimeout(handleVariantChange, 0);
      });
    }
    updateSavingCopy();

    sheet?.addEventListener('click', (event) => {
      if (event.target.closest('[data-dt-pdp-bundle-close]')) closeSheet();
    });

    if (mode === 'page') loadBundleBuilder();

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (productDetailsSheet && !productDetailsSheet.hidden) {
        closeProductDetails();
        return;
      }
      if (sheet && !sheet.hidden) closeSheet();
    });
  };
  document.querySelectorAll('[data-dt-bundle-builder-root]').forEach(initializeBundleBuilder);
})();
